import React from 'react';
import { Button, Flex } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('login.TwoFactorEnroll');
export default function TwoFactorPreActivate(props) {
  const {
    selectedMethod,
    setPreActivateData,
    preActivateSubmitVariant,
    onPreActivate,
    onBackToMethodSelect,
    backToMethodSelectVariant
  } = props;
  const Component = selectedMethod.preActivateComponent;
  return /*#__PURE__*/React.createElement(Flex, {
    variant: "colM"
  }, /*#__PURE__*/React.createElement(Component, {
    setPreActivateData: setPreActivateData
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: onPreActivate,
    variant: preActivateSubmitVariant
  }, t('submit')), /*#__PURE__*/React.createElement(Button, {
    onClick: onBackToMethodSelect,
    variant: backToMethodSelectVariant
  }, t('methodSelect')));
}